/**
 * Per-response behavioral signal tracker. Picks up paste, blur, keystroke,
 * mousemove and basic device fingerprint. Resets between questions; the
 * snapshot is shipped with each answer for downstream quality scoring.
 */

let counters = { paste: 0, blur: 0, keystrokes: 0, mousemoves: 0, copy: 0 };
let qStart = null;
let lastMouseMove = 0;
let initialized = false;

function init() {
  if (initialized || typeof document === 'undefined') return;
  initialized = true;

  document.addEventListener('paste', () => {
    counters.paste += 1;
  });
  document.addEventListener('copy', () => {
    counters.copy += 1;
  });
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) counters.blur += 1;
  });
  document.addEventListener('keydown', () => {
    counters.keystrokes += 1;
  });
  document.addEventListener(
    'mousemove',
    () => {
      const now = Date.now();
      if (now - lastMouseMove > 50) {
        counters.mousemoves += 1;
        lastMouseMove = now;
      }
    },
    { passive: true }
  );
}

function startQuestion() {
  counters = { paste: 0, blur: 0, keystrokes: 0, mousemoves: 0, copy: 0 };
  qStart = Date.now();
}

function snapshot(questionRenderTs) {
  const duration =
    questionRenderTs && Number.isFinite(questionRenderTs)
      ? Date.now() - questionRenderTs
      : qStart
      ? Date.now() - qStart
      : null;

  let tz = '';
  try {
    tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch (e) {
    /* old browsers */
  }

  return {
    dur: duration,
    paste: counters.paste,
    copy: counters.copy,
    blur: counters.blur,
    keys: counters.keystrokes,
    mm: counters.mousemoves,
    ua: navigator.userAgent || '',
    lang: navigator.language || '',
    plat: navigator.platform || '',
    sw: window.screen ? window.screen.width : 0,
    sh: window.screen ? window.screen.height : 0,
    dpr: window.devicePixelRatio || 1,
    hc: navigator.hardwareConcurrency || 0,
    tz,
    ts: Date.now(),
  };
}

const api = { init, startQuestion, snapshot };

export default api;
